export interface SimpleSet<T = boolean> {
  [key: string]: T | undefined;
}

/**
 * removes a key from a set. these sets are implemented as objects where
 * the keys of the object are the members of the set. the value is ignored.
 */
export function remove<T>(set: SimpleSet<T>, keyToDelete: string) {
  return Object.entries(set)
    .filter(([key]) => key !== keyToDelete.toString())
    .reduce(
      (newSet, [key, value]) => {
        newSet[key] = value;
        return newSet;
      },
      {} as SimpleSet<T>,
    );
}

/**
 * adds a key to the set. these sets are implements as objects where the keys of
 * the object are the members of the set. the value is ignored.
 */
export function add<T>(set: SimpleSet<T>, keyToAdd: string, value: T = true as any) {
  return { ...set, [keyToAdd]: value };
}

/**
 * checks whether or not a key exists in a set
 * @template T
 * @param {{[key: string]: T | undefined}} set
 * @param {string} key
 */
export function has<T>(set: SimpleSet<T>, key: string) {
  return !!set[key];
}

/**
 * toggles a key in a set
 */
export function toggle<T>(set: SimpleSet<T>, keyToToggle: string, value: T = true as any) {
  if (has(set, keyToToggle)) {
    return remove(set, keyToToggle);
  }

  return add(set, keyToToggle, value);
}
